export const getStage = state => state.login.stage;
export const getSignUpModalStatus = state => state.home.openLogin;
export const getLoginRequestLoading = state => state.login.loginLoading;
export const getLoginError = state => state.login.loginError;
export const getSetPasswordLoading = state => state.login.setPasswordLoading;
export const getSetPasswordError = state => state.login.setPasswordError;
